import * as React from "react";
import {useRef} from 'react';
import { Flex, Box } from 'reflexbox';
import {Center, H2} from "../typography/styled/typography";
import {CTA} from "../featured/styled/featured";
import {Container} from "../layout/container";
import ContactForm from "../../features/ContactForm/ContactForm";
import scrollIntoView from 'scroll-into-view';
import { Translate } from '../tr';

export const Proposal = () => {
  const myRef = useRef(null);

  return (
    <Container>
      {/*<Testimonial/>*/}

      <Center>
        <H2><Translate text={'Haven\'t you find what you\'ve searched for?'} /></H2>
        <p style={{ marginBottom: 40 }}><Translate text={'I will help you to choose your personal motive.'} /></p>
        <CTA onClick={() => {
          scrollIntoView(myRef.current, { time: 500 });
        }}><Translate text={'Paint me a picture'} /></CTA>
      </Center>

      <Flex flexWrap={'wrap'} justifyContent={'center'}>
          <Box ref={myRef} width={[1, 1, 3/5]}>
            <ContactForm recaptchaKey={'6Le-9nQUAAAAABSeZRmb6L8nnTpimXXod_kLJVDO'} />
          </Box>
      </Flex>

    </Container>
  );
};
